module.exports = __webpack_public_path__ + "static/img/whatsapp.6c76a3b5.png";